import React, {useState} from "react";

/**
 * Shared tab container for ENIGOOTurnstiles pages.
 *
 * tabs = [{ label, icon?, count?, content }]
 */
const CustomTabs = ({tabs}) => {
    const [active, setActive] = useState(0);
    if (!tabs || !tabs.length) return null;
    return (
        <div>
            <div style={{display:"flex",gap:"3px",marginBottom:"0"}}>
                {tabs.map((tab, i) => (
                    <button
                        key={i}
                        onClick={() => setActive(i)}
                        style={active === i
                            ? {background:"#2563eb",color:"#fff",border:"none",borderRadius:"7px 7px 0 0",padding:"7px 14px",fontSize: "var(--enigoo-fs-xs)",fontWeight:700,cursor:"pointer",display:"flex",alignItems:"center",gap:"5px",letterSpacing:"0.05em",textTransform:"uppercase"}
                            : {background:"#e2e8f0",color:"#64748b",border:"none",borderRadius:"7px 7px 0 0",padding:"7px 14px",fontSize: "var(--enigoo-fs-xs)",fontWeight:600,cursor:"pointer",display:"flex",alignItems:"center",gap:"5px",letterSpacing:"0.05em",textTransform:"uppercase"}
                        }
                    >
                        {tab.icon}
                        {tab.label}
                        {tab.count > 0 && (
                            <span style={{
                                background: active === i ? "rgba(255,255,255,0.25)" : "rgba(0,0,0,0.12)",
                                borderRadius:"999px",padding:"1px 6px",fontSize: "var(--enigoo-fs-2xs)",fontWeight:700,
                                minWidth:"18px",textAlign:"center",
                            }}>
                                {tab.count}
                            </span>
                        )}
                    </button>
                ))}
            </div>
            <div style={{background:"#fff",border:"1px solid #e2e8f0",borderRadius:"0 8px 8px 8px",padding:"16px",boxShadow:"0 1px 3px rgba(0,0,0,0.05)"}}>
                {tabs.map((tab, i) => (
                    <div key={i} style={{display: active === i ? "block" : "none"}}>
                        {tab.content}
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CustomTabs;
